module.exports = __webpack_public_path__ + "img/OurJourney2017.436591f7.png";